import React from 'react'

const PageLoading: React.FC = () => (
  <div
    role="status"
    aria-live="polite"
    aria-busy="true"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem',
      color: '#6b7280',
      fontSize: '0.875rem',
      gap: '0.5rem',
    }}
  >
    <span
      aria-hidden="true"
      style={{
        width: '1rem',
        height: '1rem',
        border: '2px solid #e5e7eb',
        borderTopColor: '#2563EB',
        borderRadius: '50%',
        display: 'inline-block',
        animation: 'spin 0.8s linear infinite',
      }}
    />
    読み込み中...
    <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
  </div>
)

export default PageLoading
